// DESIGN-01: optional decorative hero video. Empty by design: no video element or request.
// The existing admin-managed homepage_hero image remains the default image and video poster.
export const HOME_HERO_VIDEO_URL = '';
